import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/bim360-matrix-react-button';
import ModalConfirmation from '@adsk/bim360-matrix-react-modal-confirmation';
import i18n from '../../../utils/i18n';

class IssueTypesAdminChangeStatusModal extends PureComponent {
  closeModal() {
    this.props.onModalClose();
  }

  onConfirm() {
    this.props.onConfirm(this.props.data);
  }

  _renderModalMessage() {
    return (
      <div className="IssueTypesAdminChangeStatusModal">
        <p className="IssueTypesAdminChangeStatusModal__text">{i18n.t('issueTypes.modal.changeSubTypeStatusAlert')}</p>
        <p className="IssueTypesAdminChangeStatusModal__text">
          {i18n.t('issueTypes.modal.changeSubTypeStatusConfirm')}
        </p>
      </div>
    );
  }

  render() {
    return (
      <ModalConfirmation
        show={this.props.isOpen}
        onConfirm={this.onConfirm.bind(this)}
        title={i18n.t('issueTypes.modal.changeStatusTitle')}
        message={this._renderModalMessage()}
        onHide={this.closeModal.bind(this)}
        onExited={this.closeModal.bind(this)}
        container={this.props.container}
        hideOnConfirm
        confirmationButtonLabel={i18n.t('issueTypes.modal.change')}
        confirmationButtonStyleType={Button.StyleType.PRIMARY}
        cancelButtonLabel={i18n.t('issueTypes.modal.cancel')}
      />
    );
  }
}

IssueTypesAdminChangeStatusModal.displayName = 'IssueTypesAdminChangeStatusModal';

IssueTypesAdminChangeStatusModal.defaultProps = {
  data: {}
};

IssueTypesAdminChangeStatusModal.propTypes = {
  container: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.object,
  onConfirm: PropTypes.func,
  onModalClose: PropTypes.func
};

export default IssueTypesAdminChangeStatusModal;
